import { Stack, SxProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import KeyTypeEnum, { getKeyTypeLabel } from '~enums/keyTypeEnum';
import { BaseReference } from '~interfaces';
import { Dimens } from '~themes';

import Dropdown from './dropdown';

interface KeyTypesDropdownProps {
	label?: string;
	placeholder?: string;
	selectedValue?: KeyTypeEnum;
	onValueChanged: (newValue?: KeyTypeEnum) => void;
	disableClearable?: boolean;
	sx?: SxProps;
}

const KeyTypesDropdown = ({ disableClearable = false, ...props }: KeyTypesDropdownProps) => {
	const { t } = useTranslation();

	// Data
	const allTypes = Object.values(KeyTypeEnum).map((type) => ({
		id: type as string,
		name: getKeyTypeLabel(type, t),
	})) as BaseReference[];

	const handleOptionSelected = (value: BaseReference | null) => {
		const selectedType = value ? (value.id as KeyTypeEnum) : undefined;
		props.onValueChanged(selectedType);
	};

	// Component
	return (
		<Stack sx={{ gap: Dimens.spacingXs }}>
			{props.label && <Typography variant='labelSm'>{props.label}</Typography>}
			<Dropdown
				value={
					props.selectedValue ?
						{
							id: props.selectedValue,
							name: getKeyTypeLabel(props.selectedValue, t),
						}
					:	undefined
				}
				values={allTypes}
				sx={props.sx}
				canClear={!disableClearable}
				onValueChanged={handleOptionSelected}
				placeholder={props.placeholder ?? t('key.fields.typeSelectPlaceholder', { ns: 'entities' })}
			/>
		</Stack>
	);
};

export default KeyTypesDropdown;
